import React from 'react';
import './About.css'
import Hero from '../../../../components/home/Hero/Hero';
import { Link } from 'react-router-dom';
import fileIcon from '../../../../assets/images/fileIcon.svg'
import globalIcon from '../../../../assets/images/globalIcon.svg'
import tableIcon from '../../../../assets/images/tableIcon.svg'
import whoWeAreImg1 from '../../../../assets/images/about/who-we-are1.png'
import whoWeAreImg2 from '../../../../assets/images/about/who-we-are2.png'
import whoWeAreImg3 from '../../../../assets/images/about/who-we-are3.png'
import whatWeDoImg1 from '../../../../assets/images/about/what-we-do1.png'
import whatWeDoImg2 from '../../../../assets/images/about/what-we-do2.png'
import whatWeDoImg3 from '../../../../assets/images/about/what-we-do3.png'
import whatWeDoImg4 from '../../../../assets/images/about/what-we-do4.png'
import whatWeDoImg5 from '../../../../assets/images/about/what-we-do5.png'
import globalMapImg from '../../../../assets/images/about/world-map.png'
import westernSaharaFlag from '../../../../assets/images/about/westernFlagIcon.svg'
import mwaliFlagIcon from '../../../../assets/images/about/mwaliFlagIcon.svg'
import anjouanFlagIcon from '../../../../assets/images/about/turkeyFlagIcon.svg'
import maltaFlagIcon from '../../../../assets/images/about/maltaFlagIcon.svg'
import cyprusFlagIcon from '../../../../assets/images/about/cuprysFlagIcon.svg'
import gilbarFlagIcon from '../../../../assets/images/about/gibraltarFlagIcon.svg'
import isleFlagIcon from '../../../../assets/images/about/isleFlagIcon.svg'
import panamaFlagIcon from '../../../../assets/images/about/panamaFlagIcon.svg'
import seychellesFlagIcon from '../../../../assets/images/about/SeychlessFlagIcon.svg'
import maurituisFlagIcon from '../../../../assets/images/about/mauritiusFlagIcon.svg'
import luciaFlagIcon from '../../../../assets/images/about/luciaFlagIcon.svg'
import vincentFlagIcon from '../../../../assets/images/about/vincentFlagIcon.svg'
import uaeFlagIcon from '../../../../assets/images/about/uaeFlagIcon.svg'
import singaporeFlagIcon from '../../../../assets/images/about/singaporeFlagIcon.svg'
import indonesiaFlagIcon from '../../../../assets/images/about/indonesiaFlagIcon.svg'
import ukFlagIcon from '../../../../assets/images/about/ukFlagIcon.svg'
import spainFlagIcon from '../../../../assets/images/about/spainFlagIcon.svg'
import greeceFlagicon from '../../../../assets/images/about/greeceFlagIcon.svg'
import italyFlagIcon from '../../../../assets/images/about/italyFlagIcon.svg'
import whiteArrow from '../../../../assets/images/Home/whiteArrow.svg'
import Discover from '../../../../components/Discover/Discover';
import OherPractices from '../../../../components/OtherPractices/OherPractices';
import ContactFormWithBackground from '../../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground';
import {Helmet} from "react-helmet";


const breadcrumbs = [
    { name: 'Home', link: '/' },
    { name: 'About the Company', link: '/about' },
  ];

function About() {

    const protectingItemsArr = [
        {
            id: 1,
            img: fileIcon,
            title: 'Trusted Expertise'
        },
        {
            id: 2,
            img: globalIcon,
            title: 'Global Reach'
        },
        {
            id: 3,
            img: tableIcon,
            title: 'End-to-End Solutions'
        },
    ]

    const whatWeDoItemsArr = [
        {
            id: 1,
            title: 'Company-formation',
            descr: 'Incorporate global entities such as IBCs, PT PMA (Indonesia), LTDs, and PLCs with full structuring, compliance, and documentation support.',
            img: whatWeDoImg1
        },
        {
            id: 2,
            title: 'Licensing Solutions',
            descr: 'Obtain international licenses for Gaming, Banking, Brokerage, Crypto, Insurance, and Asset Management. We handle the full process from application to approval.',
            img: whatWeDoImg2
        },
        {
            id: 3,
            title: 'Banking & FinTech',
            descr: 'Open offshore and onshore bank accounts, and acquire EMI or PSP licenses for digital payment operations and FinTech platforms.',
            img: whatWeDoImg3
        },
        {
            id: 4,
            title: 'Residency & Citizenship',
            descr: 'Access Golden Visa programs in Spain, Greece, and Italy, UAE residency solutions, and Indonesia Investor KITAS for business mobility and relocation.',
            img: whatWeDoImg4
        },
        {
            id: 5,
            title: 'Asset Protection & Tax Planning',
            descr: 'Secure your wealth with non-dom regimes, trust structures, and global tax optimization tailored to your personal and corporate needs.',
            img: whatWeDoImg5
        },

    ]

    const whyClientsTrustArr = [
        {
            id: 1,
            point: '(01)',
            title: 'Global Network',
            descr: 'We collaborate with regulators, registered agents, and law firms across major financial centers to deliver seamless cross-border solutions.'
        },
        {
            id: 2,
            point: '(02)',
            title: 'One-Stop Shop',
            descr: 'From company incorporation to licensing, banking, and immigration — everything you need to expand globally is managed under one roof.'
        },
         {
            id: 3,
            point: '(03)',
            title: 'Compliance Focused',
            descr: 'Our operations are fully transparent, ethical, and aligned with international AML, KYC, and FATF standards to ensure long-term business integrity.'
        },
         {
            id: 4,
            point: '(04)',
            title: 'Tailored Solutions',
            descr: 'We don’t believe in one-size-fits-all. Every client receives a customized structure designed around their goals, jurisdiction, and business model.'
        },
         {
            id: 5,
            point: '(05)',
            title: 'End-to-End Support',
            descr: 'From initial setup and registration to renewals and ongoing compliance, our team provides continuous guidance at every stage of your journey.'
        },
    ]

    const contrysArr = [
        {
            id: 1,
            title: 'Western Sahara',
            img: westernSaharaFlag
        },
        {
            id: 2,
            title: 'Mwali (Comoros)',
            img: mwaliFlagIcon
        },
        {
            id: 3,
            title: 'Anjouan',
            img: anjouanFlagIcon
        },
        {
            id: 4,
            title: 'Malta',
            img: maltaFlagIcon
        },
        {
            id: 5,
            title: 'Cyprus',
            img: cyprusFlagIcon
        },
        {
            id: 6,
            title: 'Gibraltar',
            img: gilbarFlagIcon
        },
        {
            id: 7,
            title: 'Isle of Man',
            img: isleFlagIcon
        },
        {
            id: 8,
            title: 'Panama',
            img: panamaFlagIcon
        },
        {
            id: 9,
            title: 'Seychelles',
            img: seychellesFlagIcon
        },
        {
            id: 10,
            title: 'Mauritius',
            img: maurituisFlagIcon
        },
        {
            id: 11,
            title: 'St. Lucia',
            img: luciaFlagIcon
        },
        {
            id: 12,
            title: 'St. Vincent',
            img: vincentFlagIcon
        },
        {
            id: 13,
            title: 'UAE',
            img: uaeFlagIcon
        },
        {
            id: 14,
            title: 'Singapore',
            img: singaporeFlagIcon
        },
        {
            id: 15,
            title: 'Indonesia',
            img: indonesiaFlagIcon
        },
        {
            id: 16,
            title: 'UK',
            img: ukFlagIcon
        },
        {
            id: 17,
            title: 'Spain',
            img: spainFlagIcon
        },
        {
            id: 18,
            title: 'Greece',
            img: greeceFlagicon
        },
        {
            id: 19,
            title: 'Italy',
            img: italyFlagIcon
        },
    ]

    const meetOurClientsKeysArr = [
        {
            id: 1,
            point: '(01)',
            title: 'Brokers & FinTech Startups',
            descr: 'Seeking Forex & Payments licenses'
        },
        {
            id: 2,
            point: '(02)',
            title: 'Banks & Financial Institutions',
            descr: 'Expanding offshore'
        },
        {
            id: 3,
            point: '(03)',
            title: 'iGaming Operators',
            descr: 'Entering regulated markets'
        },
        {
            id: 4,
            point: '(04)',
            title: 'High-Net-Worth Individuals (HNWIs)',
            descr: 'Securing Golden Visas & tax optimization'
        },
    ]

    return (
        <main className='main'>
            <Helmet>
                <title>Offshore Advisory International | Global Business Experts</title>
                <meta name="description" content="Global advisory firm helping businesses with offshore setup, licensing, tax planning, and international investment solutions." />
                <meta name="keywords" content="
                    offshore advisory services, international business consulting, offshore company formation, global tax planning, business licensing services, residency by investment, fintech advisory, corporate structuring
                "
                />
            </Helmet>

            <Hero breadcrumbs={breadcrumbs} contentCenter={true} pretitle='About the Company' title='Your Global Partner in Offshore Licensing, Company Formation & Residency' descr='Offshore Advisory provides professional consulting, legal, tax and auditing services.Our specialists provide the following services globally.' backgroundImg='aboutHeader' />
           
            <section
                className='about-section section'
            >
                <div className='protecting-assets-container'>
                    <h2 className='protecting-title'>
                        Protecting Assets and Unlocking New Markets Worldwide
                    </h2>
                    <div className='protecting-assets-descr-wrapper'>
                        <p className='protecting-assets-descr'>
                            At Offshore Advisory, we help entrepreneurs, financial institutions, and international investors navigate the complex world of offshore structuring, licensing, and global residency solutions. With a presence across multiple jurisdictions, we specialize in creating tailored strategies that protect assets, optimize taxation, and unlock new markets.
                        </p>
                    </div>
                    <div className='protecting-assets-keys-row'>
                        {protectingItemsArr.map((item) => (
                            <div className='protecting-assets-item' key={item.id}>
                                <div className='protecting-assets-item-img-wrapper'>
                                    <img src={item.img} alt={item.title} />
                                </div>
                                <h3 className='protecting-assets-item-title'>
                                    {item.title}
                                </h3>
                            </div>
                        ))}
                        
                    </div>
                </div>
                <div className='who-we-are-background'>
                    <div className='who-we-are-container'>
                        <div className='who-we-are-item'>
                            <div className='who-we-are-img-wrapper'>
                                <img src={whoWeAreImg1} alt='Who we are' />
                            </div>
                            <div className='who-we-are-item-content'>
                                <h3 className='who-we-are-item-title'>
                                    Who We Are
                                </h3>
                                <p>
                                    Offshore Advisory is an international consultancy providing corporate, financial, and immigration services across 20+ jurisdictions.
                                </p><br/>
                                <p>
                                    We work with clients from startups and fintech companies to licensed banks, brokers, and gaming operators, delivering fast, compliant, and seamless support — from banking and iGaming licenses to UAE residency and beyond.
                                </p>
                            </div>
                        </div>
                        <div className='who-we-are-item'>
                            <div className='who-we-are-img-wrapper'>
                                <img src={whoWeAreImg2} alt='Our vision' />
                            </div>
                            <div className='who-we-are-item-content'>
                                <h3 className='who-we-are-item-title'>
                                    Our Vision
                                </h3>
                                <p>
                                    To be the most trusted partner for global entrepreneurs and financial institutions looking to expand, relocate, or protect their wealth worldwide.
                                </p>
                            </div>
                            
                        </div>
                        <div className='who-we-are-item'>
                            <div className='who-we-are-img-wrapper'>
                                <img src={whoWeAreImg3} alt='Our mission' />
                            </div>
                           <div className='who-we-are-item-content'>
                                 <h3 className='who-we-are-item-title'>
                                    Our Mission
                                </h3>
                                <p>
                                    To simplify international business by delivering clear, compliant, and cost-effective solutions for company formation, licensing, and residency.
                                </p>
                           </div>
                            
                        </div>
                    </div>
                </div>
                <div className='what-we-do-container'>
                    <h2 className='what-we-do-title'>
                        What We Do
                    </h2>
                    <span className='what-we-do-sub-title'>
                        We offer a full suite of offshore corporate and financial services, including:
                    </span>
                    {whatWeDoItemsArr.map((itemBlock) => (
                        <div className='what-we-do-item-block' key={itemBlock.id}>
                            <div className='what-we-do-item-left'>
                                <h3 className='what-we-do-item-title'>
                                    {itemBlock.title}
                                </h3>
                                <p className='what-we-do-item-descr'>
                                    {itemBlock.descr}
                                </p>
                            </div>
                            <div className='what-we-do-item-right'>
                                <img src={itemBlock.img} alt={itemBlock.title} />
                            </div>
                        </div>
                    ) )}
                    
                </div>
                <div className='why-clients-trust-background'>
                    <div className='why-clients-trust-container'>
                        <div className='why-clients-trust-left'>
                            <h2 className='why-clients-trust-title'>
                                Why Clients Trust Offshore Advisory
                            </h2>
                            <span>
                                Seamless, compliant, and tailored offshore solutions
                            </span>
                        </div>
                        <div className='why-clients-trust-right'>
                            {whyClientsTrustArr.map((item) => (
                                <div className='why-clients-turst-item' key={item.id}>
                                    <span className='why-clients-trust-item-point'>
                                        {item.point}
                                    </span>
                                    <h3 className='why-clients-trust-item-title'>
                                        {item.title}
                                    </h3>
                                    <p className='why-clients-trust-item-descr'>
                                        {item.descr}
                                    </p>
                                </div>
                            ))}
                            
                        </div>
                    </div>
                </div>
                <div className='global-presence-container'>
                    <div className='global-presence-left'>
                        <h2 className='global-presence-title'>
                            Our Global Presence
                        </h2>
                        <span>
                            We operate across leading offshore and financial hubs, including:
                        </span>
                        <div className='global-presence-countrys-row'>
                            {contrysArr.map((country) => (
                                <div className='country-item' key={country.id}>
                                    <div className='country-image-wrapper'>
                                        <img src={country.img} alt={country.title} />
                                    </div>
                                    <span className='title-country'>
                                        {country.title}
                                    </span>
                                </div>
                            ))}
                            
                        </div>
                    </div>
                    <div className='global-presence-right'>
                            <img src={globalMapImg} alt='World map' />
                    </div>
                </div>
                <div className='meet-our-clients-background'>
                    <div className='meet-our-content-container'>
                        <h2 className='meet-our-title'>
                            Meet Our Clients
                        </h2>
                        <span className='meet-our-sub-title'>
                            Our clients include:
                        </span>
                        <div className='meet-keys-row'>
                            {meetOurClientsKeysArr.map((item) => (
                                 <div className='meet-keys-item' key={item.id}>
                                    <div className='meet-keys-left'>
                                    <span>
                                        {item.point}
                                    </span>
                                    <h3>
                                        {item.title}
                                    </h3>
                                    </div>
                                    <div className='meet-keys-left'>
                                        {item.descr}
                                    </div>
                                </div>   
                            ))} 
                        </div>
                    </div>
                </div>
                <div className='offshore-advisory-background'>
                    <div className='offshore-advisory-container'>
                        <h2 className='offshore-advisory-title'>
                            Offshore Advisory is your trusted partner for building, protecting, and expanding your business globally
                        </h2>
                        <div className='offshore-advisory-btn-wrapper'>
                            <Link to='/newsletter'>
                                Free Consultation Today
                                <img src={whiteArrow} alt='' />
                            </Link>
                        </div>
                    </div>
                </div>
                <Discover />
                <OherPractices />
                <ContactFormWithBackground />
            </section>
            {/* <Footer /> */}
        </main>
    );
}

export default About;
